import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { AppointmentType } from 'kb-shared/types';
import { ReduxState } from 'kb-shared';
import { connect } from 'react-redux';
import { ReactComponent as AppointmentIcon } from '../../../assets/icons/appointment.svg';
import { YellowButton } from 'components/Buttons';

interface Props {
  appointmentType: AppointmentType;
  appointmentTypeIds: Array<number | string>;
  isLoggedIn: boolean;
}

const AppointmentTypeCard = ({ appointmentType, appointmentTypeIds, isLoggedIn }: Props) => {
  const history = useHistory();
  const scheduleUrl =
    appointmentTypeIds.length > 1
      ? `/${
          isLoggedIn ? 'Book' : 'create-account'
        }?step=location&appointment_types=${appointmentTypeIds.join(',')}`
      : `/${isLoggedIn ? 'Book' : 'create-account'}?step=location&appointment_id=${
          appointmentTypeIds[0]
        }`;

  return (
    <Container>
      <Card>
        <AppointmentIcon />
        <Name>{appointmentType.name}</Name>
        <Description>{appointmentType.description}</Description>
      </Card>
      <ScheduleButton
        onClick={() => {
          if (window.analytics) {
            window.analytics.track('Appointment Selected');
          }
          history.push(scheduleUrl);
        }}
      >
        Schedule Appointment
      </ScheduleButton>
    </Container>
  );
};

const mapStateToProps = ({ patient: { isLoggedIn } }: ReduxState) => ({
  isLoggedIn: isLoggedIn
});

export default connect(mapStateToProps)(AppointmentTypeCard);

const Container = styled.div`
  text-align: center;
`;

const Card = styled.div`
  align-items: center;
  border-radius: 4px;
  border: 1px solid gray;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 1em 2em;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    min-width: 500px;
    width: min-content;
  }
`;

const Name = styled.h2`
  ${({ theme }) => theme.fonts.DomaineDisplay}
  font-size: 1.5em;
  margin: 1em;
`;

const Description = styled.p`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  margin-bottom: 1em;
  text-align: center;
`;

const ScheduleButton = styled(YellowButton)`
  margin: 2em;
`;
